import { Container } from './styles'

const education = [
  {
    degree: "Master's in Media Arts and Computer Science (MACS)",
    school: 'New Mexico Highlands University, Las Vegas, NM',
    time: '08/2022 - 05/2025',
    detail: 'GPA: 3.72/4.00 - AI, Neural Networks, ML Algorithms, Image Processing',
  },
  {
    degree: "Master's in Economics (MSc)",
    school: 'Quaid-e-Azam University, Islamabad, Pakistan',
    time: '01/2013 - 01/2015',
  },
]

const experience = [
  {
    role: 'Graduate Assistant',
    place: 'New Mexico Highlands University, Las Vegas, NM',
    time: '08/2022 - 12/2024',
  },
  {
    role: 'Operations Manager',
    place: 'TransNet Enterprises LLC, Houston, TX',
    time: '01/2022 - 07/2022',
  },
]

const skills = [
  'Python',
  'SQL',
  'Power BI',
  'Excel',
  'LLMs',
  'LangChain',
  'Neural networks',
  'Vision-language models',
  'Azure',
  'Data storytelling',
  'Web scraping',
  'Agentic AI',
  'Dashboards',
  'Automation',
]

export function About() {
  return (
    <Container id="about">
      <div className="section-heading">
        <p className="eyebrow">Background</p>
        <h2>About Me</h2>
        <p className="intro">
          Data Analyst with 3+ years of experience transforming complex datasets into actionable insights that drive
          strategic decisions. I enjoy conducting market and economic analysis to better understand trends, identify
          opportunities, and inform strategic initiatives. Skilled in Python, SQL, and Power BI for data analysis,
          visualization, and problem-solving, with a proven ability to translate data into meaningful outcomes.
          Passionate about leveraging analytical expertise to improve education, empower decision-making, and deliver
          measurable impact for individuals and organizations.
        </p>
      </div>

      <div className="info-grid">
        <div className="info-card">
          <h3>Focus</h3>
          <p>
            Skilled in advanced analysis, visualization, and problem solving with a passion for measurable impact and
            decision-ready storytelling.
          </p>
          <ul>
            <li>
              <strong>AI/ML:</strong> Supervised &amp; Unsupervised Learning, Neural Networks, LLMs, LangChain, Vision-language Models
            </li>
            <li>
              <strong>Cloud &amp; Web:</strong> Microsoft Azure, Web Scraping, Agentic AI frameworks
            </li>
            <li>
              <strong>Data &amp; BI:</strong> Python, SQL, Power BI, Excel, automation
            </li>
          </ul>
        </div>

        <div className="info-card">
          <h3>Experience</h3>
          {experience.map((item) => (
            <div className="item" key={item.role}>
              <p className="title">{item.role}</p>
              <p className="meta">{item.place}</p>
              <p className="time">{item.time}</p>
            </div>
          ))}
        </div>

        <div className="info-card">
          <h3>Education</h3>
          {education.map((item) => (
            <div className="item" key={item.degree}>
              <p className="title">{item.degree}</p>
              <p className="meta">{item.school}</p>
              <p className="time">{item.time}</p>
              {item.detail && <p className="detail">{item.detail}</p>}
            </div>
          ))}
        </div>
      </div>

      <div className="skill-pills" aria-label="Key skills">
        {skills.map((skill) => (
          <span className="pill" key={skill}>
            {skill}
          </span>
        ))}
      </div>
    </Container>
  )
}
